export interface FileResponseItem {
  blobGUID: string;
  fileContent: string;
  fileName: string;
}
